import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const Tile = styled.div`
  margin-right: 24px;
  ${props => props.active && `
    color: ${props.theme.bodyColor};
  `};
`;

const SelectedLine = styled.div`
  width: 100%;
  height: 0px;
  border: 2px solid #000000;
  margin-top: 16px;
`;

const Name = styled.span`
  text-transform: uppercase;
  font-size: 16px;
`;

export default function MenuItem({
  name, active, onClick,
}) {
  const clickHandler = e => {
    e && e.preventDefault();
    if (!active) {
      onClick();
    }
  };

  return (
    <Tile active={active} onClick={clickHandler}>
      <Name>{name}</Name>
      {!!active && <SelectedLine />}
    </Tile>
  );
}

MenuItem.propTypes = {
  name: PropTypes.string.isRequired,
  active: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired,
};
